export var EditorSrc;
(function (EditorSrc) {
    EditorSrc[EditorSrc["X"] = 110] = "X";
    EditorSrc[EditorSrc["CLASSIC"] = 38] = "CLASSIC";
})(EditorSrc || (EditorSrc = {}));
export const createBIEvent = (biEventDefinition) => biEventDefinition;
export const createBIEventFactory = (src) => (evid, fields) => createBIEvent({ evid, src, fields });
const hasResponsiveBI = (editorWindow) => editorWindow.hasOwnProperty('responsiveEditorModel');
export const createComponentBI = (biLogger, extraParams = {}) => (event, eventParams) => {
    if (!(event.eventId || event.evid)) {
        return;
    }
    const params = {
        ...extraParams,
        ...eventParams,
    };
    if (hasResponsiveBI(window)) {
        const logger = window.responsiveEditorModel.bi.biLoggerFactory.logger();
        return logger.report({
            endpoint: 'editor-x',
            ...event,
            params: {
                ...params,
                componentType: extraParams.component_type,
            },
        });
    }
    return biLogger?.(event, params);
};
export const createClassicBIEvent = createBIEventFactory(EditorSrc.CLASSIC);
export const createXBIEvent = createBIEventFactory(EditorSrc.X);
//# sourceMappingURL=createBI.js.map